<a
  style="height: 21px"
  class="fw-bold text-decoration-none text-secondary"
  [ngbPopover]="accountBox"
  #popoverTrigger="ngbPopover"
  placement="bottom-end"
  [autoClose]="false"
  (shown)="disableScroll()"
  (hidden)="enableScroll()"
  role="button"
>
  Filter Services</a
>
<ng-template #accountBox>
  <div class="d-flex flex-row-reverse">
    <a type="button" role="button" (click)="popoverTrigger.close()">
      <digital-platform-icon
        icon="X"
        color="red"
        [width]="24"
        [height]="24"
      ></digital-platform-icon>
    </a>
  </div>
  <div class="d-flex align-items-start flex-column bd-highlight mb-2">
    <h5 class="mb-10 d-block d-xl-none">Filter Facilities By</h5>
    <div class="h-75">
      <div class="mb-8 h-7" *ngFor="let service of getAvailableServices">
        <label class="label-container fs-7 align-items-center">
          <input
            class="form-check-input boxes d-flex p-1"
            type="checkbox"
            name="serviceCheckbox"
            [checked]="availableServices[service]"
            [(ngModel)]="selectedServicesObject[service]"
            (change)="handleSelection()"
          />
          {{ service }}
        </label>
      </div>
    </div>
    <div class="mt-6 d-flex align-items-end">
      <digital-platform-button
        style="margin-right: 4px"
        (click)="applyServices(popoverTrigger)"
        [disabled]="!hasSelectedServices"
        color="primary"
        size="lg"
        backgroundType="light"
        label="Apply"
        buttonType="submit"
      >
      </digital-platform-button>
      <digital-platform-button
        (click)="clearAll()"
        [disabled]="!hasSelectedServices"
        color="primary"
        size="lg"
        backgroundType="light"
        label="Clear All"
        buttonType="reset"
      >
      </digital-platform-button>
    </div>
  </div>
</ng-template>
